import {
    Avatar,
    Chip,
    IconButton,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Stack,
    SvgIconProps,
    Tooltip
} from "@mui/material";
import {FileDownloadOutlined} from "@mui/icons-material";
import {ElementType} from "react";


export interface DocumentListItemProps {
    icon: ElementType<SvgIconProps>;
    primaryText: string;
    secondaryText?: string;
    badge?: string;
    badgeTooltip?: string;
    disabled?: boolean;
    onDownload?: () => void;
}

export default function DocumentListItem(props: Readonly<DocumentListItemProps>) {
    const {icon: Icon, primaryText, secondaryText, badge, badgeTooltip, disabled, onDownload} = props;

    const primary = badge
        ? (
            <Stack direction={"row"} spacing={1} alignItems={"center"}>
                <span>{primaryText}</span>
                <Tooltip title={badgeTooltip ?? ""}>
                    <Chip label={badge} size={"small"} variant={"outlined"} color={"default"}/>
                </Tooltip>
            </Stack>
        )
        : primaryText;

    return (
        <ListItem>
            <ListItemAvatar>
                <Avatar>
                    <Icon/>
                </Avatar>
            </ListItemAvatar>
            <ListItemText primary={primary} secondary={secondaryText}/>
            <ListItemSecondaryAction>
                <Stack direction={"row"} spacing={0}>
                    <IconButton disabled={disabled} onClick={() => onDownload?.()}>
                        <FileDownloadOutlined />
                    </IconButton>
                </Stack>
            </ListItemSecondaryAction>
        </ListItem>
    );
}